import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Banner2 from "../assets/images/2.jpg";
import Banner1 from "../assets/images/1.jpg";
import Banner3 from "../assets/images/3.jpg";
import Hero from "../../Sections/Hero";

export const BannerSection = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "linear",
    customPaging: (index) => (
      <button className="custom-dot" onClick={() => handleDotClick(index)}>
        {index + 1}
      </button>
    ),
  };

  const handleDotClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  return (
    <section id="homebanner">
      <Slider ref={sliderRef} {...settings}>
        <Hero banner={Banner3} />        
        <Hero banner={Banner1} />        
        <Hero banner={Banner2} />        
      </Slider>
      {/* <Slider ref={sliderRef} {...settings}>
        <div className="sliderrr">
          <h2>EPIC Taxas Charters</h2>
          <p className="sliderrr-p1">Your Premier Texas Gulf Coast Yacht Charter Company.</p>
          <p className="sliderrr-p2">Bring 5 of your closest friends and enjoy time on the water, the best way possible!</p>
          <div className="slider-bg-overlay">
            <div className="slider-bg">
              <img src={Banner2} alt="Banner 3" />
            </div>
          </div>
        </div>
        <div className="sliderrr">
          <h2>EPIC Taxas Charters</h2>
          <p className="sliderrr-p1">Your Premier Texas Gulf Coast Yacht Charter Company.</p>
          <p className="sliderrr-p2">Bring 5 of your closest friends and enjoy time on the water, the best way possible!</p>
          <div className="slider-bg-overlay">
            <div className="slider-bg">
              <img src={Banner1} alt="Banner 3" />
            </div>
          </div>
        </div>
        <div className="sliderrr">
          <h2>EPIC Taxas Charters</h2>
          <p className="sliderrr-p1">Your Premier Texas Gulf Coast Yacht Charter Company.</p>
          <p className="sliderrr-p2">Bring 5 of your closest friends and enjoy time on the water, the best way possible!</p>
          <div className="slider-bg-overlay">
            <div className="slider-bg">
              <img src={Banner3} alt="Banner 3" />
            </div>
          </div>
        </div>
      </Slider> */}
    </section>
  );
};

export default BannerSection;
